import config from '../../config';
import { handleErrors } from '../../js/helpers/handleErrors';
import { store } from '../../store';
import { IOccupancyFilter, EStatisticsGraphView } from '../data';

export function getOccupancy (
    filter: IOccupancyFilter
) {
    let dataToSend: {
        date: {
            from: string,
            to: string
        }[],
        zones?: number[],
        group?: EStatisticsGraphView
    } = {
        date: filter.dateRanges,
        zones: filter.zones,
        group: filter.graphView
    }

    return fetch(config.api.occupancy, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.getState().userStore.token}`
            },
            credentials: 'include',
            body: JSON.stringify(dataToSend)
        })
            .then(handleErrors)
            .then(res => res.json())
            .then(res => {
                return res
            })
            .catch((error: any) => {
                return null
            })
}

export default getOccupancy